import React, { FC } from "react";
import { Theme, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Field, FormRenderProps } from "react-final-form";
import BootstrapInput from "../../../components/BootstrapInput";
import Button from "../../../components/Button";
import Loading from "../../../components/Loading";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    "& + &": {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontWeight: "bold",
    fontSize: 22,
    marginBottom: 40,
  },
  button: {
    marginTop: 40,
  },
}));

const SubscriptionPaymentForm: FC<FormRenderProps> = ({
  submitting,
  handleSubmit,
}) => {
  const classes = useStyles();

  return (
    <form noValidate onSubmit={handleSubmit}>
      {submitting && <Loading />}
      <Typography align="center" component="h1" className={classes.title}>
        Subscribe to our news feed for updates on new programs
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          name="name"
          label="Full Name"
          placeholder="John Smith"
          component={BootstrapInput}
        />
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          name="email"
          label="Email"
          placeholder="johnsmith@example.com"
          component={BootstrapInput}
        />
      </Typography>
      <Typography align="center" component="div" className={classes.button}>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Subscribe ($1.99 per month)
        </Button>
      </Typography>
    </form>
  );
};

export default SubscriptionPaymentForm;
